// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";
import { dateSchema } from "../commonSchemas";

export const path = "get-loads-for-invoice";

export const getLoadsForInvoiceParamsSchema = z.object({
  invoiceId: z.string().uuid().nullable(),
});

export const loadForInvoiceSchema = z.object({
  id: z.string(),
  name: z.string(),
  pickupStart: dateSchema.nullable(),
  pickupEnd: dateSchema.nullable(),
  deliveryStart: dateSchema.nullable(),
  deliveryEnd: dateSchema.nullable(),
  weightPounds: z.number(),
  pieces: z.number(),
  chargeCarrier: z.number(),
  chargeReceiver: z.number(),
  carrierName: z.string().nullable(),
  driverName: z.string(),
  pickupLocation: z.string(),
  deliveryLocation: z.string(),
});

export const getLoadsForInvoiceResponseSchema = z.array(loadForInvoiceSchema);




export type GetLoadsForInvoiceParams = z.infer<
  typeof getLoadsForInvoiceParamsSchema
>;

export type GetLoadForInvoice = z.infer<typeof loadForInvoiceSchema>;

export type GetLoadsForInvoiceResponse = z.infer<
  typeof getLoadsForInvoiceResponseSchema
>;




// loads/get-loads-for-invoice endpoint
export function getLoadsForInvoice(
  params: z.input<typeof getLoadsForInvoiceParamsSchema>
): Promise<GetLoadsForInvoiceResponse> {
  return requestHandler(
    "loads/get-loads-for-invoice",
    params,
    getLoadsForInvoiceResponseSchema,
  );
}

